import {IntermediatePart} from "../../intermediatePart";
import {ShowerBodyType} from "../../constants";
import {Shower} from "../../parts/shower";

export default class ShowerGlass extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_glass';
    this.partName = 'Glass';
    this.translateId = "visualizer.bathroom.shower.shower_glass";
    this.visible = false;
    this.layerPriority = 12;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShowerGlass())
  }

  setLayers(layout) {

    if (this.getParent().showerTubComboIsActive()) {
      super.hideLayers();
      return;
    }

    if (this.getParent().customBodyType === ShowerBodyType.Door) {
      this.disabled = true;
    }
    this.activeFeature = this.features.find((feature) => {
      const showerBodyActiveFeature = this.getParent().showerBody.activeFeature;
      return showerBodyActiveFeature && feature.partName === showerBodyActiveFeature.partName  // set the same glass as Body
    });
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType() === Shower.Type.Custom && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Shower.Glass;
    }
  }
}
